export default __webpack_public_path__ + "static/media/pic15.3905ae83.jpg";